/**
 * `Field` (rótulo + controle) do formulário de Plano de Ação — compartilhado MPA +
 * baixa da TARP (GUPM-213). Migrado de `features/planos/planoFormUi.tsx`.
 */
import type { ReactNode } from 'react';
import { labelCls } from './estilos';

/** Campo rotulado (label + controle). `span` ocupa as 2 colunas do grid do formulário. */
export function Field({ label, span, children }: { label: string; span?: boolean; children: ReactNode }) {
  return (
    <label className={`flex flex-col gap-1 ${span ? 'col-span-2' : ''}`}>
      <span className={labelCls}>{label}</span>
      {children}
    </label>
  );
}
